var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34341 2.54395H4.6787C2.75991 2.54395 1.75232 3.55144 1.75232 5.46129V7.12583C1.75232 9.03569 2.75991 10.0432 4.66994 10.0432H6.33465C8.24468 10.0432 9.25227 9.03569 9.25227 7.12583V5.46129C9.26103 3.55144 8.25344 2.54395 6.34341 2.54395Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.358 2.54395H14.6933C12.7832 2.54395 11.7756 3.55144 11.7756 5.46129V7.12583C11.7756 9.03569 12.7832 10.0432 14.6933 10.0432H16.358C18.268 10.0432 19.2756 9.03569 19.2756 7.12583V5.46129C19.2756 3.55144 18.268 2.54395 16.358 2.54395Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.358 12.5576H14.6933C12.7832 12.5576 11.7756 13.5651 11.7756 15.475V17.1395C11.7756 19.0494 12.7832 20.0568 14.6933 20.0568H16.358C18.268 20.0568 19.2756 19.0494 19.2756 17.1395V15.475C19.2756 13.5651 18.268 12.5576 16.358 12.5576Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.34341 12.5576H4.6787C2.75991 12.5576 1.75232 13.5651 1.75232 15.475V17.1395C1.75232 19.0581 2.75991 20.0656 4.66994 20.0656H6.33465C8.24468 20.0656 9.25227 19.0581 9.25227 17.1483V15.4837C9.26103 13.5651 8.25344 12.5576 6.34341 12.5576Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.d90f8a3eef67e4a86e79377733de6d71.svg";
export { ForwardRef as ReactComponent };